/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var _ = require('underscore');

var SideNavSectionView = require('common/views/SideNavSectionView');
var openInNewTab = require('common/util/openInNewTab');
var toggleForm = require('common/util/toggleForm');

var DepFilingPointOfContactSectionView = require('../../views/DepFilingPointOfContactSectionView');
var DepFilingLawyerSectionView = require('../../views/DepFilingLawyerSectionView');
var DepFilingInstructionsSectionView = require('../../views/DepFilingInstructionsSectionView');
var DepFilingSupportingDocumentsSectionView = require('../../views/DepFilingSupportingDocumentsSectionView');

var DepBankAcquisitionMergerApplicationInfoSectionView = require('./DepBankAcquisitionMergerApplicationInfoSectionView');
var DepBankAcquisitionMergerConfirmationSectionView = require('./DepBankAcquisitionMergerConfirmationSectionView');
var DepBankAcquisitionMergerPubReqsSectionView = require('./DepBankAcquisitionMergerPubReqsSectionView');
var DepBankAcquisitionMergerNameReservationsSectionView = require('./DepBankAcquisitionMergerNameReservationsSectionView');
var DepBankAcquisitionMergerReqDocsSectionView = require('./DepBankAcquisitionMergerReqDocsSectionView');
var DepBankAcquisitionMergerQuestionnaireSectionView = require('./DepBankAcquisitionMergerQuestionnaireSectionView');

var SubmitBankMergerAcqFiling = require('../../services/SubmitBankMergerAcqFiling');

require('../../styles/DepFilingPrintView.css');
var tmplDepBankAcquisitionMergerFilingView = require('./DepBankAcquisitionMergerFilingView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepBankAcquisitionMergerFilingView,

  className: 'dep-bank-acquisition-merger-filing-view m-b-md',

  behaviors: {
    ReadOnlyFormBehavior: {}
  },

  ui: {
    filingSections: '.filing-sections',
    nextButton: '.next-button',
    previousButton: '.previous-button'
  },

  events: {
    'click @ui.previousButton': 'onClickPrevious',
    'click @ui.nextButton': 'onClickNext'
  },

  regions: {
    filingSections: '@ui.filingSections'
  },

  onBeforeShow: function() {
    var filingId = this.model.get('filingId');

    var filingDetails = this.model.get('filingDetails') || {};
    var filingContent = this.model.get('filingContent') || {};
    var entityIdentifiers = this.model.get('entityIdentifiers') || {};
    var instructionsDocument = filingDetails.instructionsDocument;
    var pointOfContact = filingDetails.pointOfContact;
    var additionalInstructionDocuments = filingDetails.instructionsDocuments;
    var instructions = filingDetails.instructions;

    var stateCharters = this.model.get('stateCharters');
    var charterTypes = this.model.get('charterTypes');
    var nameTypes = this.model.get('nameTypes');
    var ownershipStructures = this.model.get('ownershipStructures');
    var regulators = this.model.get('regulators');
    var bankTypes = this.model.get('bankTypes');
    var fedReserveBanks = this.model.get('fedReserveBanks');
    var lawyers = this.model.get('lawyers') || filingDetails.lawyers;

    var mode = this.options.mode;
    var isNewExternal = mode === 'ext-new';
    var isForPrinting = mode === 'print';
    var isExpandInternal = mode === 'int-expand';

    this.form = new SideNavSectionView({
      collection: new Backbone.Collection([
        {
          id: 'pointOfContact',
          title: 'Point of Contact',
          view: new DepFilingPointOfContactSectionView({
            mode: this.options.mode,
            isReadOnly: this.options.isReadOnly,
            hasAddress: true,
            hasBusiness: true,
            model: new Backbone.Model(pointOfContact)
          })
        },
        {
          id: 'bankAquisitionMergerSubmissionLawyer',
          title: 'Filer',
          view: new DepFilingLawyerSectionView({
            mode: this.options.mode,
            isReadOnly: this.options.isReadOnly,
            model: new Backbone.Model({
              lawyers: lawyers,
              currentLawyer: filingDetails.lawyer
            })
          })
        },
        {
          id: 'applicationInfo',
          title: 'Application Information',
          view: new DepBankAcquisitionMergerApplicationInfoSectionView({
            mode: this.options.mode,
            isReadOnly: this.options.isReadOnly,
            model: new Backbone.Model({
              filingContent: filingContent,
              stateCharters: stateCharters,
              charterTypes: charterTypes,
              ownershipStructures: ownershipStructures,
              regulators: regulators,
              bankTypes: bankTypes,
              fedReserveBanks: fedReserveBanks,
              entityIdentifiers: entityIdentifiers
            })
          })
        },
        {
          id: 'instructions',
          title: 'I - General Information and Instructions',
          view: new DepFilingInstructionsSectionView({
            mode: this.options.mode,
            isReadOnly: this.options.isReadOnly,
            model: new Backbone.Model({
              instructionsDocument: instructionsDocument,
              additionalInstructionDocuments: additionalInstructionDocuments,
              instructions: instructions
            })
          })
        },
        {
          id: 'pubReqs',
          title: 'II - Publication Requirements',
          view: new DepBankAcquisitionMergerPubReqsSectionView({
            mode: this.options.mode,
            isReadOnly: this.options.isReadOnly,
            model: new Backbone.Model({ filingContent: filingContent })
          })
        },
        {
          id: 'nameRes',
          title: 'III - Name Reservations',
          view: new DepBankAcquisitionMergerNameReservationsSectionView({
            mode: this.options.mode,
            isReadOnly: this.options.isReadOnly,
            model: new Backbone.Model({
              filingContent: filingContent,
              nameTypes: nameTypes
            })
          })
        },
        {
          id: 'fedApps',
          title: 'IV - Federal Applications',
          view: new DepBankAcquisitionMergerQuestionnaireSectionView({
            mode: this.options.mode,
            isReadOnly: this.options.isReadOnly,
            model: new Backbone.Model({ filingContent: filingContent })
          })
        },
        {
          id: 'reqDocs',
          title: 'V - Bank Merger Required Documentation',
          view: new DepBankAcquisitionMergerReqDocsSectionView({
            mode: this.options.mode,
            isReadOnly: this.options.isReadOnly,
            model: new Backbone.Model({ filingContent: filingContent })
          })
        },
        {
          id: 'supportingDocuments',
          title: 'Other Supporting Documents',
          view: new DepFilingSupportingDocumentsSectionView({
            mode: this.options.mode,
            isReadOnly: this.options.isReadOnly,
            model: new Backbone.Model({
              filingDetails: filingDetails,
              filingContent: filingContent
            })
          })
        },
        {
          id: 'certification',
          title: 'Certification',
          view: new DepBankAcquisitionMergerConfirmationSectionView({
            mode: this.options.mode,
            isReadOnly: this.options.isReadOnly,
            model: new Backbone.Model({
              filingId: filingId,
              bankMergerAcqFilingId: filingContent.bankMergerAcqFilingId,
              filingDetails: filingDetails
            })
          })
        }
      ]),
      useNavigationButtons: false,
      expanded: isForPrinting || isExpandInternal,
      contentWidth: 'medium',
      useNavigationSavePrevButtons: !this.options.isReadOnly,
      buttons: [
        {
          buttonText: 'Save',
          buttonClass: 'btn-default ladda-button',
          buttonIconClass: 'fa-save',
          labelClass: 'ladda-label',
          buttonAttrs: {
            'data-style': 'expand-right'
          },
          onClick: this.onClickSave.bind(this)
        },
        {
          buttonText: 'Save & Print',
          buttonClass: 'btn-default ladda-button',
          buttonIconClass: 'fa-print',
          labelClass: 'ladda-label',
          buttonAttrs: {
            'data-style': 'expand-right'
          },
          onClick: this.onClickPrint.bind(this)
        }
      ]
    });

    if (this.options.isReadOnly) {
      this.form.collection.remove(this.form.collection.get('instructions'));
      this.form.collection.remove(this.form.collection.get('certification'));
    }

    // If this isn't the new external form, or if the form is in print mode, remove the buttons
    if (!isNewExternal || isForPrinting) {
      this.form.options.buttons = [];
    }

    this.showChildView('filingSections', this.form);
  },

  onAttach: function() {
    if (this.options.mode === 'print') {
      this.switchToPrint();
    }
  },

  switchToPrint: function() {
    var textAreas = $('.input-view');

    _.each(textAreas, function(textArea) {
      var textAreaVal = textArea.value;
      var textAreaName = textArea.name;
      var printElementId = '#'.concat(textAreaName, 'PrintView');
      $(printElementId).text(textAreaVal);
    });
    toggleForm(textAreas, false);
  },

  onClickNext: function(e) {
    var l = Ladda.create(e.currentTarget);
    l.start();

    this.saveForm()
      .done(function() {
        l.stop();
      })
      .fail(function() {
        l.stop();
      });
    window.scrollTo(0, 0);
  },

  onClickPrevious: function(e) {
    var l = Ladda.create(e.currentTarget);
    l.start();

    this.saveForm()
      .done(function() {
        l.stop();
      })
      .fail(function() {
        l.stop();
      });
    window.scrollTo(0, 0);
  },

  onClickSave: function(e) {
    var l = Ladda.create(e.currentTarget);
    l.start();

    this.saveForm()
      .done(function() {
        l.stop();
      })
      .fail(function() {
        l.stop();
      });
  },

  onClickPrint: function(e) {
    var filingId = this.model.get('filingId');
    var l = Ladda.create(e.currentTarget);
    l.start();

    this.saveForm()
      .done(function() {
        openInNewTab('#ext/dep/filing/' + filingId + '/print');
        l.stop();
      })
      .fail(function() {
        l.stop();
      });
  },

  saveForm: function() {
    var deferred = $.Deferred();
    var self = this;
    var filingId = this.model.get('filingId');
    var filingContent = this.model.get('filingContent') || {};

    this.form
      .validateAll({ type: 'save' })
      .done(function() {
        var formData = self.form.getFormData();
        formData.filingId = filingId;
        formData.bankMergerAcqFilingId = filingContent.bankMergerAcqFilingId;
        SubmitBankMergerAcqFiling(formData)
          .done(function() {
            deferred.resolve();
          })
          .fail(function() {
            deferred.reject();
          });
      })
      .fail(function() {
        deferred.reject();
      });
    return deferred.promise();
  }
});
